export default __webpack_public_path__ + "static/media/cl.f477fc62.svg";